import { ExperimentType } from 'utils/experiment/types';

export const EXPERIMENT_HANDRAISER_STC: ExperimentType = {
  name: 'ngcp-chat-handraiser-stc',
  buckets: {
    control: 'control',
    'handraiser-landing': 'handraiser-landing',
    'handraiser-offer': 'handraiser-offer',
  },
} as const;

export const EXPERIMENT_HANDRAISER_SRP: ExperimentType = {
  name: 'ngcp-sebs-handraiser-srp-compare',
  buckets: {
    control: 'control',
    handraiser: 'handraiser',
  },
} as const;
